module.exports = __webpack_public_path__ + "static/images/zc.e200c4f.png";